<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="submission-overlay"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="submission-card">
        <div class="submission-illustration mb-3">
          <img
            :src="require('@/assets/writing_feature/books.gif')"
            :alt="imageAlt"
            height="163"
          />
        </div>
        <h2 class="submission-title">{{ title }}</h2>
        <p class="submission-subtitle">
          {{ subtitleText }}
          <span class="loading-dots"><span>.</span><span>.</span><span>.</span></span>
        </p>
        <p class="submission-meta">{{ metaText }}</p>
        <div class="submission-progress-wrap mb-3">
          <div class="submission-progress-pulse"></div>
        </div>
        <p class="submission-step mb-1">{{ loadingStepMessage }}</p>
        <p v-if="showLongWaitMessage" class="submission-long-wait mb-2">
          Still working - this can take a bit longer for detailed feedback.
        </p>
        <p class="submission-safe mb-0">{{ safeText }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "FeedbackGenerationModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loadingStepMessage: {
      type: String,
      default: ""
    },
    showLongWaitMessage: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Your essay has been submitted."
    },
    subtitleText: {
      type: String,
      default: "Generating your feedback"
    },
    metaText: {
      type: String,
      default: "This usually takes about 20-40 seconds."
    },
    safeText: {
      type: String,
      default: "Your work is safe - do not refresh or close this page."
    },
    imageAlt: {
      type: String,
      default: "Generating feedback"
    }
  }
};
</script>

<style scoped>
.submission-overlay {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.submission-card {
  width: 100%;
  max-width: 620px;
  background: #ffffff;
  border: 1px solid #e8e8ef;
  border-radius: 16px;
  box-shadow: 0 20px 45px rgba(19, 23, 33, 0.12);
  padding: 1.75rem;
  text-align: center;
}

.submission-illustration img {
  max-width: 40%;
  height: auto;
}

.loading-dots span {
  opacity: 0;
  animation: dotFade 1.5s ease-in-out infinite;
}

.loading-dots span:nth-child(1) {
  animation-delay: 0s;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.25s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.5s;
}

@keyframes dotFade {
  0%,
  60%,
  100% {
    opacity: 0;
  }

  30% {
    opacity: 1;
  }
}

.submission-progress-wrap {
  width: 100%;
  background: #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  height: 8px;
}

.submission-progress-pulse {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #8c30f5 0%, #b07ef5 50%, #8c30f5 100%);
  background-size: 200% 100%;
  border-radius: 8px;
  animation: progressPulse 2s ease-in-out infinite;
}

@keyframes progressPulse {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

.submission-title {
  font-size: 1.4rem;
  line-height: 1.3;
  margin-bottom: 0.5rem;
  color: #1f2937;
}

.submission-subtitle {
  font-size: 1.05rem;
  margin-bottom: 0.3rem;
  color: #374151;
}

.submission-meta {
  font-size: 0.95rem;
  color: #6b7280;
  margin-bottom: 1rem;
}

.submission-step {
  font-weight: 600;
  color: #3f3f46;
  min-height: 1.5rem;
}

.submission-long-wait {
  color: #92400e;
  font-weight: 600;
}

.submission-safe {
  color: #4b5563;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 576px) {
  .submission-card {
    padding: 1.25rem;
  }

  .submission-title {
    font-size: 1.2rem;
  }
}
</style>
